<template>
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
    <el-form-item label="视频高度：">
         <el-input v-model="curItem.params.height" style="width: 200px;"></el-input>vh
       </el-form-item>

            <!-- 视频类型选择 -->
            <el-form-item label="视频类型：">
        <el-select v-model="curItem.params.videoType"  @change="handleVideoTypeChange"
  :validate-event="false" placeholder="请选择视频类型" style="width: 200px;">

          <el-option label="企业" value="company"></el-option>
          <el-option label="政府" value="government"></el-option>
          <el-option label="商会" value="shanghui"></el-option>
          <el-option label="跨境云" value="crossBorder"></el-option>
        </el-select>
      </el-form-item>



         <el-form-item label="">
         <el-input v-model="curItem.params.height" style="width: 200px;"></el-input>vh
       </el-form-item>


      <!-- 图片表格 -->
      <el-form-item label="图片表格：">
        <el-table :data="imageTableData" border style="width: 100%">
          <el-table-column prop="image" label="图片" width="150">
            <template slot-scope="scope">
              <div class="image-uploader">
                <img v-if="scope.row.imgUrl" :src="scope.row.imgUrl" class="image-preview" @click="handleImageClick(scope.$index)"/>
                <div v-else class="image-uploader-trigger" @click="handleImageClick(scope.$index)">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="text" label="文字内容">
            <template slot-scope="scope">
              <el-input v-model="scope.row.text" placeholder="请输入文字内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="链接URL">
            <template slot-scope="scope">
              <el-input v-model="scope.row.linkUrl" placeholder="请输入链接URL"></el-input>
              <el-button type="primary" size="mini" @click="changeLink(scope.$index)" style="margin-top: 5px;">
                选择链接
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="removeImageRow(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="d-c-c mt-10">
          <el-button @click="addImageRow">添加一行</el-button>
        </div>
      </el-form-item>

      <!-- 原有导航项设置 -->
      <el-form-item label="导航项：">
        <draggable class="wrapper" v-model="curItem.data" :options="{ animation: 120, filter: '.drag__nomove' }">
          <div class="param-img-item" :key="index" v-for="(navBar, index) in curItem.data">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="$parent.onEditorDeleleData(index, selectedIndex)"></i>
            </div>
            <!-- 原有导航项内容保持不变 -->
            <!-- ... -->
          </div>
        </draggable>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>

      <SetLink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkSet">选择链接</SetLink>
    </el-form>
  </div>
</template>

<script>
import SetLink from '@/components/setlink/Setlink';
import draggable from "vuedraggable";
import selectIcon from "@/components/page/selectIcon";
export default {
  components: {
    SetLink,
    draggable,
    selectIcon,
  },
  data() {
    return {
      is_linkset: false,
      index: null,
      imageTableData: [],
      currentImageIndex: -1,
      currentLinkIndex: -1
    };
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  created() {
    // 初始化图片表格数据
    if (this.curItem.imageTableData) {
      this.imageTableData = JSON.parse(JSON.stringify(this.curItem.imageTableData));
    } else {
      this.imageTableData = [
        { imgUrl: '', text: '', linkUrl: '' }
      ];
    }

    // 监听父组件的图片选择完成事件
    this.$parent.$on('image-selected', this.handleImageSelected);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$parent.$off('image-selected', this.handleImageSelected);
  },
  methods: {
    /* 图片上传相关方法 */
    handleImageClick(index) {
      this.currentImageIndex = index;
      this.$parent.onEditorSelectImage(this.imageTableData[index], 'imgUrl');
    },
    handleVideoTypeChange(val) {
    this.$nextTick(() => {
      this.$forceUpdate(); // 强制更新视图
    });
  },

    // 处理图片选择完成事件
    handleImageSelected({ target, imgUrl }) {
      if (this.currentImageIndex >= 0 && target === 'imgUrl') {
        this.imageTableData[this.currentImageIndex].imgUrl = imgUrl;
        this.$set(this.imageTableData, this.currentImageIndex, {...this.imageTableData[this.currentImageIndex]});
        this.saveImageTableData();
      }
    },

    /* 链接选择相关方法 */
    changeLink(index) {
      this.currentLinkIndex = index;
      this.is_linkset = true;
    },

    closeLinkSet(e) {
      if (e && this.currentLinkIndex >= 0) {
        this.imageTableData[this.currentLinkIndex].linkUrl = e.url;
        this.imageTableData[this.currentLinkIndex].name = '链接到' + ' ' + e.type + ' ' + e.name;
        this.$set(this.imageTableData, this.currentLinkIndex, {...this.imageTableData[this.currentLinkIndex]});
        this.saveImageTableData();
      }
      this.is_linkset = false;
      this.currentLinkIndex = -1;
    },

    /* 表格操作 */
    addImageRow() {
      this.imageTableData.push({ imgUrl: '', text: '', linkUrl: '' });
      this.saveImageTableData();
    },

    removeImageRow(index) {
      this.imageTableData.splice(index, 1);
      this.saveImageTableData();
    },

    saveImageTableData() {
      this.curItem.imageTableData = JSON.parse(JSON.stringify(this.imageTableData));
      this.$emit('update-data', this.curItem);
    }
  },
  watch: {
    imageTableData: {
      deep: true,
      handler() {
        this.saveImageTableData();
      }
    }
  }
};
</script>

<style>
/* 图片上传样式 */
.image-uploader {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.image-uploader:hover {
  border-color: #409EFF;
}

.image-uploader-trigger {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #8c939d;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mt-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Swipervideo.vue